export class CustomAgenda {
	constructor() {
	}
} 
